import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

class PaymentTypeDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
  	if (this.props.data) {
  		return (
  			<div>{this.props.data == 'reservation_balance' || this.props.data == 'reservation_deposit' || this.props.data == 'room_charge' ? I18n.t(this.props.data) : this.props.data}</div>
  		);
  	} else if (this.props.row && this.props.row.product) {
  		return (
  			<div>{this.props.row.product.name} {this.renderDate()}</div>
  		);
  	} else {
	    return (
	      <span className="none">{I18n.t('none')}</span>
	    );
  	}
  }

  renderDate() {
    if (this.props.row && this.props.row.start_date != null && this.props.row.end_date != null) {
      if (this.props.row.start_date == this.props.row.end_date) {
        return <span>({DateHelper.parseToString(this.props.row.start_date, this.props.date_format)})</span>;
      } else {
        return <span>({DateHelper.parseToString(this.props.row.start_date, this.props.date_format)} - {DateHelper.parseToString(this.props.row.end_date, this.props.date_format)})</span>;
      }
    }
  }

};

export default PaymentTypeDataType